module.exports = __webpack_public_path__ + "img/gloves_002.97f51080.png";